import config from '../config';
import Aegis from '@tencent/aegis-web-sdk';
const { aegisId } = config;
// const has = Object.prototype.hasOwnProperty;
const defaultConfig = {
  id: aegisId, // 项目ID
  uin: config.env !== 'production' ? config.env : '', // 通用用来监控某个特定用户的常规日志上报
  reportApiSpeed: true, // 接口测速
  pagePerformance: true,
  offlineLog: true,
  offlineLogExp: 7,
  api: {
    // 设置上报规则
    retCodeHandler(data) {
      let isErr = false;
      let code = 0;
      try {
        if (Object.prototype.toString.call(data) === '[object Object]') {
          if (data.body) {
            isErr = !(
              (data.body.bizcode === 0 && data.body.retcode === 0)
              || (data.body.bizcode === 0 && data.body.retcode === 1004)
              || (data.body.bizcode === 0 && data.body.retcode === 1014)
            );
            code = data.body.retcode || data.body.bizcode;
          }
        }
      } catch (e) {
        console.log(e);
      }

      return {
        isErr,
        code,
      };
    },
  },
  spa: true,
  reportAssetSpeed: true, // 静态资源测速
};

const aegis = new Aegis(defaultConfig);

window.aegis = aegis;

let events = [];
const canReport = () => {
  const route = location.pathname;
  const pageList = {
    list: ['eventsMeetingManagement', 'speakerHub'],
    mutation: ['meetingManagement/stepSubmit', 'speakerEdit'],
    detail: ['eventsMeetingDetail', 'speakerDetail'],
  };
  let name = '';
  Object.keys(pageList).forEach((key) => {
    if (pageList[key].find((i) => route.includes(i))) {
      name = key;
    }
  });
  if (name === 'mutation') {
    if (location.href.includes('?id=') || location.href.includes('&id=')) {
      name = `edit${name}`;
    } else {
      name = `create${name}`;
    }
  }
  return name;
};

const reportStart = (str) => {
  const name = canReport();
  if (name) {
    const route = location.pathname;
    const event = `aegisweb_${name}${str}_${route}`;
    console.log('meowgo', event);
    events.push(event);
    aegis.time(event);
  }
};

const reportEnd = (str) => {
  const name = canReport();
  if (name) {
    const route = location.pathname;
    const event = `aegisweb_${name}${str}_${route}`;
    if (events.includes(event)) {
      console.log('meowend', event);
      events = events.filter((i) => i !== event);
      aegis.timeEnd(event);
    }
  }
};

// 页面跳转路径上报
const reportPageNavigation = (fromPath, toPath, additionalInfo = {}) => {
  const reportData = {
    name: 'page_navigation',
    ext1: fromPath,
    ext2: toPath,
    ext3: additionalInfo.ext3 || JSON.stringify(additionalInfo),
  };

  console.log('页面跳转上报:', reportData);
  aegis.reportEvent(reportData);
};

// 无权限页面上报
const reportPermissionDenied = (pagePath, permissionType, userInfo = {}) => {
  const reportData = {
    name: 'permission_denied',
    ext1: permissionType, // layout 或 data
    ext2: pagePath,
    ext3: userInfo.uin || JSON.stringify(userInfo),
  };

  console.log('无权限上报:', reportData);
  aegis.reportEvent(reportData);

  // 同时作为错误上报
  aegis.error({
    name: 'PermissionDeniedError',
    msg: `用户无${permissionType === 'layout' ? '布局' : '数据'}权限访问页面: ${pagePath}`,
    ext1: permissionType,
    ext2: pagePath,
    ext3: JSON.stringify(userInfo),
  });
};

// 通用自定义事件上报
const reportCustomEvent = (eventName, eventData = {}) => {
  const reportData = {
    name: eventName,
    ext1: eventData.ext1 || '',
    ext2: eventData.ext2 || '',
    ext3: eventData.ext3 || '',
  };

  console.log('自定义事件上报:', reportData);
  aegis.reportEvent(reportData);
};

// 用户行为上报
const reportUserAction = (action, target) => {
  const reportData = {
    name: 'user_action',
    ext1: action,
    ext2: target,
    ext3: window.location.pathname,
  };

  console.log('用户行为上报:', reportData);
  aegis.reportEvent(reportData);
};

export {
  reportStart,
  reportEnd,
  reportPageNavigation,
  reportPermissionDenied,
  reportCustomEvent,
  reportUserAction,
};
export default aegis;
